/*
 * @Description: seo
 * @Author: hanyu
 * @Date: 2021-03-02 15:18:01
 * @LastEditTime: 2021-03-02 15:18:43
 * @LastEditors: hanyu
 */
// seo 类型
export const WEB_PAGE_TDK_PAGE_ENUM = {
    HOME: {
        value: 1,
        desc: '首页'
    },
    COURSE: {
        value: 2,
        desc: '课程'
    },
    QUESTION: {
        value: 3,
        desc: '题库'
    },
    MALL: {
        value: 4,
        desc: '图书商城'
    },
    TEACHER: {
        value: 5,
        desc: '师资'
    },
    NEWS: {
        value: 6,
        desc: '资讯'
    },
    DOWNLOAD: {
        value: 7,
        desc: '下载'
    },
    ABOUT_US: {
        value: 8,
        desc: '关于我们'
    },
    HELP_CENTER: {
        value: 9,
        desc: '帮助中心'
    }
}

export default {
    WEB_PAGE_TDK_PAGE_ENUM
};